import createModule from "../createModule"
import view from "./view"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { getPeriod, getViewType, getSelectedModelId, getCurrency, getPortfolioFxHedgeEnabled } from "modules/portfolio-root/selectors/portfolios"
import { getEarliestDate, getLatestDate } from "modules/portfolio-root/selectors/dates"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getBasePositionSet, getBaseSignature } from "selectors/base"
import { getStartDate, getEndDate, getSelectedDate, getPerformanceFetchStartDate } from "selectors/dates"
import { getCumulativeTrend, getAlphaTrend, getFactorTrend, getTradingPnl, getFirstDate, getDatesAdjusted, getResidualTrend } from "./selectors"
import { getIsOpPro } from "modules/account-root/selectors"
import { VIEW_TYPES } from "helpers/base"
import { getIsRfrAttributionEnabled } from "selectors/features"
import { getResidualAttributionSummarySubquery } from "helpers/residualAttribution"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    portfolioId: state.global.selected.portfolio,
    modelId: getSelectedModelId(state),
    period: getPeriod(state),
    base: getBasePositionSet(state),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    viewType: getViewType(state),
    baseSignature: getBaseSignature(state),
    fetchStartDate: getPerformanceFetchStartDate(state),
    currency: getCurrency(state),
    fxHedgeEnabled: getPortfolioFxHedgeEnabled(state),
    isRfrAttributionEnabled: getIsRfrAttributionEnabled(state),
  }),
  required: ["account", "portfolioId"],
  data: [{
    resource: "axiomaPerformanceHistory",
    as: null,
    url: ({ modelId, portfolioId, startDate, endDate, base, baseSignature, fetchStartDate, viewType, currency, fxHedgeEnabled, isRfrAttributionEnabled }) => {
      return {
        id: `${modelId}${portfolioId}${startDate}${fetchStartDate}${endDate}${viewType}${baseSignature}${currency}${fxHedgeEnabled}${isRfrAttributionEnabled}`,
        query: `query ($modelId: String!, $portfolioId: String!, $from: Date!, $to: Date!, $base: [PositionSetInput]) {
          model (id: $modelId) {
            simulation (positionSet: {
              type: PORTFOLIO,
              id: $portfolioId
            }, from: $from, to: $to, base: $base, interval: AUTO) {
              performance {
                date
                totalReturn {
                  cumulativePercent
                }
                attribution {
                  summary {
                    specific {
                      cumulativePercent
                    }
                    factors {
                      cumulativePercent
                    }
                    trading {
                      cumulativePercent
                    }
                    ${isRfrAttributionEnabled ? getResidualAttributionSummarySubquery() : ""}
                  }
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          portfolioId,
          from: fetchStartDate,
          to: endDate,
          base: viewType === VIEW_TYPES.ACTIVE ? [base] : undefined,
        },
      }
    },
  }],
  mapStateToProps: (state) => ({
    earliestDate: getEarliestDate(state),
    latestDate: getLatestDate(state),
    cumulativeTrend: getCumulativeTrend(state),
    alphaTrend: getAlphaTrend(state),
    tradingPnl: getTradingPnl(state),
    factorTrend: getFactorTrend(state),
    residualTrend: getResidualTrend(state),
    date: getSelectedDate(state),
    firstDate: getFirstDate(state),
    isOpPro: getIsOpPro(state),
    datesAdjusted: getDatesAdjusted(state),
  }),
  actions: {
    setDate: PortfolioRootCreators.setDate,
    resetDate: PortfolioRootCreators.resetDate,
    setPeriod: PortfolioRootCreators.setPeriod,
    addNotification: notificationsCreators.add,
  },
})
